export default __webpack_public_path__ + "static/media/a1.dfbfee38.png";